export default __webpack_public_path__ + "static/teamPhoto10-a91d495ea428fe7be1e70783ed41e65b.png";